import { Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectPhase } from 'api/project';
import {
  CustomDueDatePicker,
  DateValue,
} from 'components/atoms/due-date-picker';
import { Radio } from 'components/atoms/radio';
import { Task } from 'data/tasks';
import { MoveTaskAlertStyled } from './styled';
import { getExpectedPhaseDates, toReadableDates } from './utils';

export type BasicProjectPhase = Pick<
  ProjectPhase,
  'projectPhaseId' | 'projectPhaseName' | 'startDate' | 'dueDate'
>;

enum MoveTaskRadioOptions {
  Automatic = 1,
  Custom,
}

interface Props {
  task: Task;
  projectPhase: BasicProjectPhase;
  selected: MoveTaskRadioOptions;
  onChange: (latest: MoveTaskRadioOptions) => void;
  dates: [DateValue, DateValue];
  onDateChange: (values: [DateValue, DateValue]) => void;
}

export const RadioOptions: FC<Props> = ({
  task,
  projectPhase,
  selected,
  onChange,
  dates,
  onDateChange,
}) => {
  const handleRadioChange = (e) => {
    const {
      target: { value },
    } = e;

    onChange(value);
  };

  return (
    <MoveTaskAlertStyled.Description>
      <Radio.Group value={selected} onChange={handleRadioChange}>
        <Space direction="vertical">
          <Radio value={MoveTaskRadioOptions.Automatic}>
            <Space size={4} direction="vertical">
              <div>
                <FormattedMessage id="task.move_to_phase.alert.radio.automatic" />
              </div>
              {selected === MoveTaskRadioOptions.Automatic && (
                <MoveTaskAlertStyled.RadioDescription>
                  <FormattedMessage
                    id="task.move_to_phase.alert.radio.automatic.description"
                    values={{
                      strong: (chunks) => <strong>{chunks}</strong>,
                      currentPhaseDates: toReadableDates([
                        projectPhase.startDate,
                        projectPhase.dueDate,
                      ]),
                      expectedPhaseDates: toReadableDates(
                        getExpectedPhaseDates(projectPhase, task),
                      ),
                    }}
                  />
                </MoveTaskAlertStyled.RadioDescription>
              )}
            </Space>
          </Radio>
          <Radio value={MoveTaskRadioOptions.Custom}>
            <Space size={4} direction="vertical">
              <div>
                <FormattedMessage
                  id="task.move_to_phase.alert.radio.manual"
                  values={{ taskName: task.taskName }}
                />
              </div>

              {selected === MoveTaskRadioOptions.Custom && (
                <CustomDueDatePicker
                  onDateChange={onDateChange}
                  startDate={dates[0]}
                  dueDate={dates[1]}
                />
              )}
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
    </MoveTaskAlertStyled.Description>
  );
};
